exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".login-session-expired{text-align:center;color:#666;margin-bottom:30px}", ""]);

// exports
